<template>
  <!-- 遊客中心人次 -->
  <div class="col">
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        遊客中心人次
      </div>
      <div class="card-body p-2">
        <div class="d-flex justify-content-end">
          <button  class="btn btn-dia " style="" @click="showModal()" v-if="!isShortView">
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div style="margin: auto; max-width: 450px; margin-bottom:20px">
          <apexchart
          type="area"
          :options="sumPeopleFlowSetting"
          :series="sumPeopleFlowData"
          ></apexchart>
        </div>
        <dialog-modal  id="modalPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
          :isImage="false" :isMarginAuto="false" :modalTitle="'遊客中心人次'" :closeButton="false" >
          <div class="object-detection-detail w-75 m-auto" >
              <apexchart
                type="area"
                id="chartPop"
                :options="sumPeopleFlowSetting"
                :series="sumPeopleFlowData"
              ></apexchart>
          </div>
        </dialog-modal>
        <div class="chart-description chart-description-btm ">
          以分時呈現當日遊客中心人次（人流攝影機），08時段為08~09時段的遊客中心人次。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "../../components/DialogModal.vue";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import { postCentralPeopleFlow } from '../../api/eastCoastDataApi/ElkQuery/PeopleFlowElk'
const zh_tw = require("../../utils/apexchartObject/apexLocales/zh-tw.json");
import ApexchartObject from '../../utils/apexchartObject/centerPeopleFlow'

export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  props: {
    selectedScenicAreaId: {
      type: Number,
    },
  },

  data() {
    return {
      dataInterval: null,
      peopleAttributeListData: [],
      viewPort: window.innerWidth,
      isShortView:false,
      //  測試非空值時間資料 (上機前須更改)
      // startTime:moment().subtract(25, 'hours'),
      // endTime: moment().subtract(1, 'hours'),

      startTime:  moment().startOf("day"),
      endTime: moment().endOf("day"), //取得當日最早時間與最晚時間
      // startTime: "2023-09-05T00:00:00",
      // endTime: "2023-09-05T23:55:55",
      //VueApexCharts Setting
      sumPeopleFlowData:[],
      sumPeopleFlowSetting: ApexchartObject.realTimePeopleFlow,
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    async getCenterPeopleFlow() {
      const condition = {
        areas:[],
        sttime: moment(this.startTime).format(),
        endtime: moment(this.endTime).format(),
        interval: "hour"
      }

      if(this.selectedScenicAreaId > -1) {
        condition.areas.push(this.selectedScenicAreaId)
      }

      const result = await postCentralPeopleFlow(condition)
      if(!result.success){
        return []
      }

      const dataList = result.data.map(e => {
        const data ={}
        data.areaName = e.areaName
        data.time = `${moment(e.dateTime).format('YYYY-MM-DD')}\n${moment(e.dateTime).format('HH')}~${moment(e.dateTime).add(1, 'h').format('HH')}`
        data.peopleIn = e.peopleIn
        data.peopleOut = e.peopleOut
        data.peopleStay = e.peopleStay
        data.dateTime = e.dateTime

        return data
      })

      return dataList
    },

    setChartData(dataList) {
      // const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列

      const sumList = Object.values(dataList.reduce((acc, obj) => {
        //將相同天數的人數相加
        if (acc[obj.time]) {
          acc[obj.time].peopleStay += obj.peopleStay;
          acc[obj.time].peopleIn += obj.peopleIn;
          acc[obj.time].peopleOut += obj.peopleOut;
        } else {
          acc[obj.time] = { ...obj };
        }
        return acc;
      }, {}));

      this.sumPeopleFlowData = []
      const peopleStayCount = sumList.map((d, i) => {
        return d.peopleStay
      })

      const peopleInCount = sumList.map((d, i) => {
        return d.peopleIn
      })

      const peopleOutCount = sumList.map((d, i) => {
        return d.peopleOut
      })

      this.sumPeopleFlowData.push({name: '在園人數', data: peopleStayCount})
      this.sumPeopleFlowData.push({name: '進場人數', data: peopleInCount})
      this.sumPeopleFlowData.push({name: '離場人數', data: peopleOutCount})

      let chartSetting = {...this.sumPeopleFlowSetting}

      let xaxisCategories = sumList.map((d, i) => {
        const hour = moment(d.dateTime).format("HH:mm");
        const date = moment(d.dateTime).format("YYYY-MM-DD");
        const category = `${date} ${hour}`;
        return category
      })

      if(xaxisCategories.length === 1) {
        const data = Utils.setapexChartZero(xaxisCategories, this.sumPeopleFlowData)
        xaxisCategories = data.xaxisCategories
        this.sumPeopleFlowData = data.chartData
      }

      chartSetting.tooltip.x.formatter = function (val) {
        return `${moment(val).format("MM/DD HH")} - ${moment(val).add(1, 'hours').format("HH")} `;
      };

      chartSetting.tooltip.y.formatter = function (val) {
        return val + " 人";
      };

      chartSetting.xaxis.categories = xaxisCategories
      chartSetting.chart.toolbar.export={
              csv: {
                filename: `遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              svg: {
                filename: `遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              png: {
                filename: `遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              }
            }
            
      this.sumPeopleFlowSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },
    //取得每日遊客中心每小時性別人流量
    // async getPeopleAttributeListPerDay() {
    //   const condition = {
    //     startTime: this.startTime,
    //     endTime: this.endTime,
    //     scenicAreaId: this.selectedScenicAreaId,
    //   };

    //   await this.$store.dispatch(
    //     "peopleAttribute/getPeopleAttributeListPerHour",
    //     condition
    //   );
    //   this.peopleAttributeListData =
    //     this.$store.getters["peopleAttribute/getSearchGenderPerHour"];
    //   const a = this.peopleAttributeListData.filter((item) => {
    //     return item.scenicAreaName !== null;
    //   });
    // },

    //處理資料圖表使用
    // initGenderDataPerHour() {
    //   const genderTypes = Object.values(CONST.GENDER); //['男性', '女性']
    //   const vm = this;
    //   const seriesData = Object.keys(CONST.GENDER).map(
    //     (currentType, indexType) => {
    //       const result = {};
    //       result.name = genderTypes[indexType];
    //       result.data = vm.peopleAttributeListData.map((item, index) => {
    //         if (indexType === 0) {
    //           return item.manCount;
    //         } else {
    //           return item.womanCount;
    //         }
    //       });
    //       return result;
    //     }
    //   );

    //   this.chartSeries = seriesData;
    //   this.chartOptions.xaxis.categories = this.peopleAttributeListData.map(
    //     (current) => current.startTime
    //   );

    //   this.chartOptions.chart.toolbar.export.svg.filename = `${Utils.getSingleScenicAreaNamebyId(
    //     this.selectedScenicAreaId
    //   )}_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
    //   this.chartOptions.chart.toolbar.export.csv.filename = `${Utils.getSingleScenicAreaNamebyId(
    //     this.selectedScenicAreaId
    //   )}_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
    //   this.chartOptions.chart.toolbar.export.png.filename = `${Utils.getSingleScenicAreaNamebyId(
    //     this.selectedScenicAreaId
    //   )}_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`;
    //   this.chartOptions = { ...this.chartOptions };
    // },
  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
  },

  watch: {
    selectedScenicAreaId: {
      async handler(newVal) {
        if (newVal === null) {
          return;
        }
        const peopleCountDataList = await this.getCenterPeopleFlow();
        this.setChartData(peopleCountDataList);
      },
      immediate:true
    },

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
    
  },

  async mounted() {
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);

    this.dataInterval = setInterval(async () => {
      const peopleCountDataList = await this.getCenterPeopleFlow();
      this.setChartData(peopleCountDataList);
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
